"use client";

import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function CloudWatchForm() {
  const [cursor, setCursor] = useState({ x: 0, y: 0 });
  const [eyePos, setEyePos] = useState({ x: 0, y: 0 });
  const [blink, setBlink] = useState(false);

  useEffect(() => {
    const handleMouse = (e: MouseEvent) => setCursor({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouse);
    return () => window.removeEventListener("mousemove", handleMouse);
  }, []);

  useEffect(() => {
    const offsetX = ((cursor.x / window.innerWidth) - 0.5) * 40;
    const offsetY = ((cursor.y / window.innerHeight) - 0.5) * 20;
    setEyePos({ x: offsetX, y: offsetY });
  }, [cursor]);

  // Blinking every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setBlink(true);
      setTimeout(() => setBlink(false), 200);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center p-4">
      <div className="bg-white/30 backdrop-blur-md rounded-xl shadow-xl p-8 flex flex-col items-center gap-6 w-full max-w-md border">

        {/* Cartoon Face */}
          <div className="relative w-70 h-40">
            <img
              src="https://pub-940ccf6255b54fa799a9b01050e6c227.r2.dev/cloud.jpg"
              alt="cartoon"
              className="w-full h-full"
            />

            {["left", "right"].map((side, idx) => (
              <div
                key={side}
                className="absolute flex justify-center items-end overflow-hidden"
                style={{
                  top: 60,
                  left: idx === 0 ? 80 : 150,
                  width: 28,
                  height: blink ? 6 : 40,
                  borderRadius: blink ? "2px" : "50% / 60%",
                  backgroundColor: "white",
                  transition: "all 0.15s ease",
                }}
              >
                <div
                  className="bg-black"
                  style={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    marginBottom: 4,
                    transform: `translate(${eyePos.x}px, 0px)`,
                    transition: "all 0.1s ease",
                  }}
                />
              </div>
            ))}
          </div>

        {/* Form */}
        <div className="w-full flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <Label>Namn</Label>
            <Input placeholder="Ditt namn" />
          </div>
          <div className="flex flex-col gap-1">
            <Label>E-post</Label>
            <Input type="email" placeholder="Din e-postadress" />
          </div>
          <div className="flex flex-col gap-1">
            <Label>Telefonnummer</Label>
            <Input type="tel" placeholder="Ditt telefonnummer" />
          </div>
          <div className="flex flex-col gap-1">
            <Label>Adress</Label>
            <Input placeholder="Din adress" />
          </div>
          <div className="flex flex-col gap-1">
            <Label>Meddelande</Label>
            <textarea
              className="flex min-h-[100px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              placeholder="Beskriv ditt ärende..."
            />
          </div>
          <Button className="mt-2 w-full">Skicka</Button>
        </div>
      </div>
    </div>
  );
}
